<template>
  <div class="ai-drawer">
    <el-drawer
        :close-on-press-escape="false"
        :visible.sync="selfVisible"
        direction="rtl"
        size="70%"
        @closed="closed"
        @opened="opend"
    >
      <div class="drawer-main">
        <!--        左边-->
        <div class="left">
          <div class="let-top">
            <div class="title-container">
              <span>生成方式</span>
            </div>
            <div class="create-way">
              <el-radio-group v-model="creatWay">
                <el-radio :label="1">全自动</el-radio>
                <el-radio :label="2">半自动</el-radio>
              </el-radio-group>
            </div>
            <div class="title-container">
              <span>当前产品</span>
            </div>
            <div class="products">
              <div v-for="item in 1" :key="item" class="product">
                <el-image
                    :src="product[attrs.img]"
                    fit="fill"
                    style="width: 60px; height: 60px"></el-image>
                <span>{{ product[attrs.title] }}</span>
              </div>
            </div>
          </div>


          <div v-show="creatWay===2" class="title-container">
            <span>选择要包含的内容</span>
            <el-link :underline="false" type="primary" @click="copyContent">一键复制已选内容</el-link>
          </div>
          <div v-show="creatWay===2" class="left-bottom">

            <div class="items-container">
              <div v-show="ruleType===1" class="info-container">
                <div class="info-title">产品优势</div>
                <div>
                  <el-checkbox-group v-model="titleProductAdvantageList">
                    <el-row>
                      <el-col v-for="(item, index) in extraData.titleProductAdvantageList" :key="index" :span="12">
                        <el-checkbox :label="item.content">
                          <div>{{ item.content }}</div>
                          <div>{{ item.enContent }}</div>
                        </el-checkbox>
                      </el-col>

                    </el-row>
                  </el-checkbox-group>
                </div>
              </div>
              <div v-show="ruleType===1" class="info-container">
                <div class="info-title">促销语</div>
                <div>
                  <el-checkbox-group v-model="titlePromotionList">
                    <el-row>
                      <el-col v-for="(item, index) in extraData.titlePromotionList" :key="index" :span="12">
                        <el-checkbox :label="item.content">
                          <div>{{ item.content }}</div>
                          <div>{{ item.enContent }}</div>
                        </el-checkbox>
                      </el-col>
                    </el-row>
                  </el-checkbox-group>
                </div>
              </div>
              <div v-show="ruleType===1" class="info-container">
                <div class="info-title">服务优势</div>
                <div>
                  <el-checkbox-group v-model="titleServiceAdvantageList">
                    <el-row>
                      <el-col v-for="(item, index) in extraData.titleServiceAdvantageList" :key="index" :span="12">
                        <el-checkbox :label="item.content">
                          <div>{{ item.content }}</div>
                          <div>{{ item.enContent }}</div>
                        </el-checkbox>
                      </el-col>
                    </el-row>
                  </el-checkbox-group>
                </div>
              </div>
              <div v-show="ruleType===2" class="info-container">
                <div class="info-title">号召性用语</div>
                <div>
                  <el-checkbox-group v-model="descCalloutList">
                    <el-row>
                      <el-col v-for="(item, index) in extraData.descCalloutList" :key="index" :span="12">
                        <el-checkbox :label="item.content">
                          <div>{{ item.content }}</div>
                          <div>{{ item.enContent }}</div>
                        </el-checkbox>
                      </el-col>

                    </el-row>
                  </el-checkbox-group>
                </div>
              </div>
              <div v-show="ruleType===2" class="info-container">
                <div class="info-title">工厂优势</div>
                <div>
                  <el-checkbox-group v-model="descFactoryAdvantageList">
                    <el-row>
                      <el-col v-for="(item, index) in extraData.descFactoryAdvantageList" :key="index" :span="12">
                        <el-checkbox :label="item.content">
                          <div>{{ item.content }}</div>
                          <div>{{ item.enContent }}</div>
                        </el-checkbox>
                      </el-col>

                    </el-row>
                  </el-checkbox-group>
                </div>
              </div>
              <div v-show="ruleType===2" class="info-container">
                <div class="info-title">产品优势</div>
                <div>
                  <el-checkbox-group v-model="descProductAdvantageList">
                    <el-row>
                      <el-col v-for="(item, index) in extraData.descProductAdvantageList" :key="index" :span="12">
                        <el-checkbox :label="item.content">
                          <div>{{ item.content }}</div>
                          <div>{{ item.enContent }}</div>
                        </el-checkbox>
                      </el-col>

                    </el-row>
                  </el-checkbox-group>
                </div>
              </div>
              <div v-show="ruleType===2" class="info-container">
                <div class="info-title">促销语</div>
                <div>
                  <el-checkbox-group v-model="descPromotionList">
                    <el-row>
                      <el-col v-for="(item, index) in extraData.descPromotionList" :key="index" :span="12">
                        <el-checkbox :label="item.content">
                          <div>{{ item.content }}</div>
                          <div>{{ item.enContent }}</div>
                        </el-checkbox>
                      </el-col>

                    </el-row>
                  </el-checkbox-group>
                </div>
              </div>
              <div v-show="ruleType===2" class="info-container">
                <div class="info-title">服务优势</div>
                <div>
                  <el-checkbox-group v-model="descServiceAdvantageList">
                    <el-row>
                      <el-col v-for="(item, index) in extraData.descServiceAdvantageList" :key="index" :span="12">
                        <el-checkbox :label="item.content">
                          <div>{{ item.content }}</div>
                          <div>{{ item.enContent }}</div>
                        </el-checkbox>
                      </el-col>

                    </el-row>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--        右边-->
        <div class="right">
          <div class="progress-container">
            <el-row>
              <el-col :span="18">
                <el-progress :percentage="percent" :stroke-width="26" :text-inside="true"
                ></el-progress>
              </el-col>
              <el-col :span="6" style="line-height: 30px; text-align: right;">
                <el-button :disabled="createText==='正在生成'" size="mini" type="primary" @click="createData">
                  {{ createText }}
                </el-button>
                <el-button size="mini" @click="listreturncontent">查看生成记录</el-button>
              </el-col>
            </el-row>
          </div>

          <el-table
              :data="tableData"
              header-row-class-name="header-class"
              height="95%"
              style="width: 100%"
              @selection-change="handleSelectionChange"
          >
            <el-table-column
                type="selection"
                width="55">
            </el-table-column>
            <el-table-column
                prop="content">
              <template slot="header">
                <div class="header-container">
                  <div>广告标题</div>
                  <div>
                    <span>已选 {{ selectedNum }} 条</span>
                    <el-button type="text" @click="fillTo">一键填充</el-button>
                  </div>
                </div>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </div>
      <div slot="title" style="font-size: 16px;">
        {{ title }}
      </div>
    </el-drawer>
  </div>
</template>
<script>
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';

/**
 * 新户自动化上线 - 完善推广资料 - 标题推荐组件
 */

export default {
  name: "aiDrawer",
  props: {
    title: {
      type: String,
      default: '自动生成广告标题'
    },
    visible: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => {
      }
    },
    attrs: {
      type: Object,
      default: () => {
        return {
          img: 'imgPath',
          title:'title',
          automationContentId: 'automationContentId'
        }
      }
    },
    ruleType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      selfVisible: false,
      creatWay: 1, // 生成方式  1全自动 2半自动
      tableData: [], // 结果列表
      selected: [], // 要填充的结果
      createText: '生成',
      percent: 0,
      extraData: {}, // 要拼接的内容
      titleProductAdvantageList: [], // 标题 --- 产品优势
      titlePromotionList: [], // 标题 --- 促销语
      titleServiceAdvantageList: [], // 标题 --- 服务优势
      descCalloutList: [], // 广告说明 --- 号召性用语
      descFactoryAdvantageList: [], // 广告说明 --- 工厂优势
      descProductAdvantageList: [], // 广告说明 --- 产品优势
      descPromotionList: [], // 广告说明 --- 促销语
      descServiceAdvantageList: [], // 广告说明 --- 服务优势
      historyFlg: false, // 当前是否为 生成历史查询模式
      timmer: null, // 进度条控制
    }
  },
  computed: {
    selectedNum() {
      return this.selected.length
    },
  },
  watch: {
    visible: {
      handler(val) {
        this.selfVisible = val;
      },
      immediate: true
    }
  },
  methods: {
    // 一键复制已选内容
    copyContent() {
      // 组合所有已选内容
      let arr = this.titleProductAdvantageList.concat(this.titlePromotionList).concat(this.titleServiceAdvantageList).concat(this.descServiceAdvantageList).concat(this.descPromotionList).concat(this.descProductAdvantageList).concat(this.descCalloutList).concat(this.descFactoryAdvantageList)
      // 组合所有选项原数据
      let objArr = [];
      Object.keys(this.extraData).forEach(key => {
        if (this.extraData[key]) {
          objArr = objArr.concat(this.extraData[key]);
        }
      })
      // 从选项原数据中提取已选内容的 enContent 并复制
      let result = []
      arr.forEach(word => {
        objArr.forEach(item => {
          if (item.content === word) {
            result.push(item.enContent);
          }
        })
      })
      // 将字符串数组转换为长字符串
      const longString = result.join('\n');
      // 创建一个临时 textarea 元素
      const textarea = document.createElement('textarea');
      textarea.value = longString;
      // 将 textarea 添加到 DOM 中
      document.body.appendChild(textarea);
      // 选中 textarea 中的文本
      textarea.select();
      // 复制文本到剪贴板
      navigator.clipboard.writeText(longString)
          .then(() => {
            this.$message.success('文本已成功复制到剪贴板')
          })
          .catch((error) => {
            console.error('复制文本到剪贴板失败:', error);
            this.$message.error('复制文本到剪贴板失败')
          });

      // 移除 textarea 元素
      document.body.removeChild(textarea);
    },
    // 参数筛选方法
    filterParam(key) {
      let result = []
      this[key].forEach(word => {
        this.extraData[key].forEach(item => {
          if (item.content === word) {
            result.push(item);
          }
        })
      })
      return result;
    },
    // 生成、重新生成 的参数准备及进度条处理
    createData() {
      if (this.historyFlg === true) {
        this.tableData = [];
        this.historyFlg = false;
      }
      let param = {};
      // 全自动生成参数
      if (this.creatWay === 1) {
        param = {
          automationContentId: this.product[this.attrs.automationContentId], // 产品id
          ruleType: this.ruleType, //规则类型(1广告标题，2广告描述，3广告附加信息)
          serviceId: this.$route.query.serviceSiteId // 服务单id
        }
        this.autoCreate(param)
      } else {
        // 半自动生成参数
        param = {
          automationContentId: this.product[this.attrs.automationContentId],// 产品id
          ruleType: this.ruleType,//规则类型(1广告标题，2广告描述，3广告附加信息)
          serviceId: this.$route.query.serviceSiteId, // 服务单id
          titleProductAdvantageList: this.filterParam('titleProductAdvantageList'), // 广告标题产品优势集合
          titlePromotionList: this.filterParam('titlePromotionList'), // 广告标题促销语集合
          titleServiceAdvantageList: this.filterParam('titleServiceAdvantageList'), // 广告标题服务优势集合
          descCalloutList: this.filterParam('descCalloutList'), // 广告描述语号召性用语集合
          descFactoryAdvantageList: this.filterParam('descFactoryAdvantageList'), //广告描述语工厂优势集合
          descProductAdvantageList: this.filterParam('descProductAdvantageList'), // 广告描述语产品优势集合
          descPromotionList: this.filterParam('descPromotionList'),// 广告描述语促销语集合
          descServiceAdvantageList: this.filterParam('descServiceAdvantageList') // 广告描述语服务优势集合
        }
        this.semiautomaticrequestdata(param);
      }

      this.createText = '正在生成'

      // 进度条处理
      this.percent = 0;

      this.timer = setInterval(() => {
        if (this.percent <= 98) {
          this.percent += 1;
        } else {
          clearInterval(this.timer); // 及时清理计时器
        }
      }, 200)

    },
    // 全自动生成
    async autoCreate(param) {
      try {
        let res = await adsNewOnlineSer.automaticrequestdata(param);
        this.tableData = this.tableData.concat(res.data.contentList);
        console.log('全自动生成请求内容：', res.data.requestContent)
        this.createText = '重新生成';
        this.percent = 100;
      } catch (e) {
        this.createText = '重新生成';
        this.percent = 0;
        clearInterval(this.timer)
      }
    },
    // 半自动生成
    async semiautomaticrequestdata(param) {
      try {
        let res = await adsNewOnlineSer.semiautomaticrequestdata(param);
        this.tableData = this.tableData.concat(res.data.contentList);
        console.log('半自动生成请求内容：', res.data.requestContent)
        this.createText = '重新生成';
        this.percent = 100;
      } catch (e) {
        this.createText = '重新生成';
        this.percent = 0;
        clearInterval(this.timer)
      }
    },
    // 获取拼接内容信息
    async getmontagecontent(ruleType) {
      let res = await adsNewOnlineSer.getmontagecontent({
        ruleType
      })
      this.extraData = res.data
    },
    // 获取生成记录
    async listreturncontent() {
      this.historyFlg = true;
      let res = await adsNewOnlineSer.listreturncontent({
        automationContentId: this.product[this.attrs.automationContentId], // 产品id
        serviceId: this.$route.query.serviceSiteId, // 服务单id
        contentType: this.creatWay,// 生成方式
        ruleType: this.ruleType, // 生成类型 标题、广告描述
      })
      this.tableData = res.data;
    },
    // 一键填充
    async fillTo() {
      let res = await adsNewOnlineSer.saveselecteddata({
        automationContentId: this.product[this.attrs.automationContentId], // 产品id
        serviceId: this.$route.query.serviceSiteId, // 服务单id
        automaticReturnContentList: this.selected.map(item => item.id), // 已选中的生成结果
      })
      if (res.data === "success") {
        this.$emit('done', this.selected.map(item => {
          return {content: item.content}
        }))
        this.closed()
      }

    },
    // 结果多选
    handleSelectionChange(rows) {
      this.selected = rows
    },
    // 关闭抽屉
    closed() {
      this.selected = [];
      this.tableData = [];
      this.creatWay = 1;
      this.percent = 0;
      this.createText = '生成';
      this.titleProductAdvantageList = [], // 标题 --- 产品优势
          this.titlePromotionList = [], // 标题 --- 促销语
          this.titleServiceAdvantageList = [], // 标题 --- 服务优势
          this.descCalloutList = [], // 广告说明 --- 号召性用语
          this.descFactoryAdvantageList = [], // 广告说明 --- 工厂优势
          this.descProductAdvantageList = [], // 广告说明 --- 产品优势
          this.descPromotionList = [], // 广告说明 --- 促销语
          this.descServiceAdvantageList = [], // 广告说明 --- 服务优势
          this.$emit('update:visible', false);
    },
    // 打开抽屉动画完成时的回调
    opend() {
      this.getmontagecontent(this.ruleType)
    },
  }
}
</script>
<style lang="scss" scoped>
.el-checkbox {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.header-class {
  .header-container {
    display: flex;
    justify-content: space-between;

    &:last-child {
      span {
        margin-right: 20px;
      }
    }
  }

}

.ai-drawer {

  .create-way {
    box-sizing: border-box;
    padding: 10px;
  }
}

.drawer-main {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  font-size: 14px;
  // 包含的内容
  .info-container {
    .info-title {
      width: 100%;
      background-color: #f2f2f2;
      height: 20px;
      line-height: 20px;
      text-align: center;
      margin: 10px 0;
    }
  }

  // 产品列表
  .products {
    .product {
      width: 100%;
      height: 70px;
      border-radius: 4px;
      border: 1px solid #d9d9d9;
      margin: 10px 0;
      box-sizing: border-box;
      padding: 0 10px;
      display: flex;
      align-items: center;

      .el-image {
        margin-right: 10px;
      }
    }
  }

  // 模块标题
  .title-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    color: #777;
  }

  // 左边
  .left {
    height: 90%;
    width: 35%;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    padding: 10px;
    display: flex;
    flex-direction: column;

    .left-bottom {
      height: 500px;
      overflow-y: scroll;
    }


  }

  // 右边
  .right {
    height: 90%;
    width: 63%;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    padding: 10px;


    .progress-container {
      height: 30px;
    }
  }
}
</style>